// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"QuoteFromMedia_thecomp___MvCY"};